import { ReactNode } from "react";
import { useSamplesWaterBaseDataListQuery } from "@/services/backend/samples/api/water-base-data-api";
import { waterBaseDataKey } from "@/services/backend/samples/types/sample-base-data";
import {
  SampleBaseDataListRequest,
  SampleBaseDataTable,
  useSampleBaseDataListRequestWithCompanies,
} from "@/services/backend/samples/components/sample-base-data-table";
import { DeleteWaterBaseDataDialog } from "@/services/backend/samples/components/delete-water-base-data-dialog";

export function WaterBaseDataTable({
  request,
  onRequestChange,
  renderRowLink,
  hidePagination,
  hideBorder,
}: {
  request: SampleBaseDataListRequest;
  onRequestChange: (request: SampleBaseDataListRequest) => void;
  renderRowLink: (baseDataId: string, children: ReactNode) => ReactNode;
  hidePagination?: boolean;
  hideBorder?: boolean;
}) {
  const { request: effectiveRequest, skip } =
    useSampleBaseDataListRequestWithCompanies(request);
  const { data, isLoading, error } = useSamplesWaterBaseDataListQuery(
    effectiveRequest,
    { skip },
  );

  return (
    <SampleBaseDataTable
      data={data}
      isLoading={isLoading}
      error={error}
      dataKey={waterBaseDataKey}
      request={request}
      onRequestChange={onRequestChange}
      renderRowLink={renderRowLink}
      renderDeleteAction={(baseData) => (
        <DeleteWaterBaseDataDialog baseData={baseData} />
      )}
      hidePagination={hidePagination}
      hideBorder={hideBorder}
    />
  );
}
